// src/config/navigationConfig.js
import React from 'react';
import { ROLES } from '../constants/roles';

// Iconos
import HomeIcon from '@mui/icons-material/Home';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt'; 
import BadgeIcon from '@mui/icons-material/Badge'; 
import AccessTimeIcon from '@mui/icons-material/AccessTime'; 
import ViewWeekIcon from '@mui/icons-material/ViewWeek'; 
import DashboardIcon from '@mui/icons-material/Dashboard'; 
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'; 
import LaptopChromebookIcon from '@mui/icons-material/LaptopChromebook'; 
import EventBusyIcon from '@mui/icons-material/EventBusy'; 
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn'; 
import EventIcon from '@mui/icons-material/Event';
import BeachAccessIcon from '@mui/icons-material/BeachAccess'; 
import SettingsIcon from '@mui/icons-material/Settings'; 
import StorageIcon from '@mui/icons-material/Storage'; 
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ReceiptIcon from '@mui/icons-material/Receipt';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';

// CATEGORIAS FISICAS (CARPETAS)
export const CATEGORIES = {
  HR: 'Talento Humano',
  SYSTEM: 'Configuración y Sistema'
};

/**
 * ESQUEMA DE PERMISOS SUGERIDO:
 * Para cada sección, definimos un permiso que debe ser activado en la App (Admin Dashboard)
 */
export const navigationItems = [
  // --- SECCIÓN: GENERAL ---
  {
    title: "Inicio",
    path: "/dashboard",
    icon: <HomeIcon />,
    roles: [], // Libre acceso para logueados
    category: CATEGORIES.HR,
    description: "Panel principal de control"
  },

  // --- SECCIÓN: NÚCLEO DE TALENTO ---
  {
    title: "Gestión de Personal",
    section: "Talento Humano",
    category: CATEGORIES.HR,
    icon: <PeopleAltIcon />,
    requiredPermission: "view_personal_module", // Carpeta principal
    basePath: "/talento-humano/personal",
    subItems: [
      {
        title: "Directorio",
        path: "/talento-humano/directorio",
        icon: <BadgeIcon />,
        requiredPermission: "view_directory",
        description: "Listado activo y fichas de personal"
      },
      {
        title: "Bajas de Personal",
        path: "/talento-humano/bajas",
        icon: <PersonRemoveIcon />,
        requiredPermission: "manage_exits",
        description: "Gestión de desvinculaciones e inactivos"
      },
      {
        title: "Activos Asignados",
        path: "/talento-humano/activos",
        icon: <LaptopChromebookIcon />,
        requiredPermission: "view_assets",
        description: "Equipos y materiales entregados"
      },
    ]
  },

  // --- SECCIÓN: CONTROL DE ASISTENCIA ---
  {
    title: "Control de Asistencia",
    section: "Asistencia",
    category: CATEGORIES.HR,
    icon: <AccessTimeIcon />,
    requiredPermission: "view_attendance_module",
    basePath: "/talento-humano/control",
    subItems: [
      {
        title: "Marcaciones Diarias",
        path: "/talento-humano/asistencia",
        icon: <AccessTimeIcon />,
        requiredPermission: "view_daily_attendance",
        description: "Reporte de entradas y salidas hoy"
      },
      {
        title: "Pivot Semanal",
        path: "/talento-humano/asistencia-semanal",
        icon: <ViewWeekIcon />,
        requiredPermission: "view_weekly_attendance",
        description: "Vista de asistencia semanal"
      },
      {
        title: "Consolidado Extra",
        path: "/talento-humano/asistencia-consolidado",
        icon: <DashboardIcon />,
        requiredPermission: "view_consolidated_attendance",
        description: "Análisis de horas y horas extra"
      },
      {
        title: "Monitor en VIVO",
        path: "/talento-humano/control-en-vivo",
        icon: <NotificationsActiveIcon />,
        requiredPermission: "view_realtime_monitor",
        description: "Alertas de faltas en tiempo real"
      },
      {
        title: "Reporte Mensual Avanzado",
        path: "/talento-humano/reporte-mensual",
        icon: <AssessmentIcon />,
        requiredPermission: "view_monthly_advanced_report",
        description: "Análisis biométrico completo (Horas Extra/Nocturnas)"
      },
    ]
  },

  // --- SECCIÓN: PERMISOS Y FERIADOS ---
  {
    title: "Permisos y Feriados",
    section: "Tiempos",
    category: CATEGORIES.HR,
    icon: <EventIcon />,
    requiredPermission: "view_time_module",
    basePath: "/talento-humano/tiempos",
    subItems: [
      {
        title: "Justificaciones",
        path: "/talento-humano/justificaciones",
        icon: <AssignmentTurnedInIcon />,
        requiredPermission: "manage_justifications",
        description: "Gestión de permisos y licencias"
      },
      {
        title: "Vacaciones",
        path: "/talento-humano/vacaciones",
        icon: <BeachAccessIcon />,
        requiredPermission: "manage_justifications",
        description: "Cálculo y gestión de vacaciones según legislación boliviana"
      },
      {
        title: "Historial de Ausencias",
        path: "/talento-humano/ausencias",
        icon: <EventBusyIcon />,
        requiredPermission: "view_absences",
        description: "Reporte histórico de faltas"
      },
      {
        title: "Días Festivos",
        path: "/talento-humano/dias-festivos",
        icon: <EventIcon />,
        requiredPermission: "manage_holidays",
        description: "Calendario de feriados"
      },
    ]
  },

  // --- SECCIÓN: PLANILLAS Y SUELDOS ---
  {
    title: "Planillas y Sueldos",
    section: "Remuneraciones",
    category: CATEGORIES.HR,
    icon: <ReceiptIcon />,
    requiredPermission: "view_payrolls",
    basePath: "/talento-humano/planillas",
    subItems: [
      {
        title: "Planillas Generadas",
        path: "/talento-humano/planillas",
        icon: <ReceiptIcon />,
        requiredPermission: "view_payrolls",
        description: "Gestión y visualización de planillas mensuales"
      },
      {
        title: "Configuración de Empleados",
        path: "/talento-humano/configuracion-planilla",
        icon: <SettingsApplicationsIcon />,
        requiredPermission: "manage_payroll_config",
        description: "Configurar AFP, horas extra y bonos por empleado"
      },
      {
        title: "Variables Mensuales",
        path: "/talento-humano/variables-mensuales",
        icon: <AssessmentIcon />,
        requiredPermission: "manage_monthly_variables",
        description: "Gestión de variables calculadas y manuales"
      },
      {
        title: "Descuentos al Personal",
        path: "/talento-humano/descuentos-personal",
        icon: <AccountBalanceWalletIcon />,
        requiredPermission: "manage_deductions",
        description: "Adelantos fraccionados y descuentos por productos"
      },
    ]
  },

  // --- SECCIÓN: ADMINISTRACIÓN ---
  {
    title: "Gestión del Sistema",
    section: "Administración",
    category: CATEGORIES.SYSTEM,
    icon: <AdminPanelSettingsIcon />,
    requiredPermission: "view_system_admin",
    basePath: "/admin",
    subItems: [
      {
        title: "Configuración General",
        path: "/administracion",
        icon: <SettingsIcon />,
        requiredPermission: "manage_global_settings",
        description: "Ajustes globales del sistema"
      },
      {
        title: "Centro de Seguridad",
        path: "/admin/security",
        icon: <AdminPanelSettingsIcon />,
        requiredPermission: "manage_security",
        description: "Gestión de usuarios, roles y permisos del sistema"
      },
      {
        title: "Guía de Accesos",
        path: "/admin/security/guide",
        icon: <AssignmentTurnedInIcon />,
        requiredPermission: "manage_security",
        description: "Explicación técnica del funcionamiento de permisos"
      },
      {
        title: "Explorador de Datos",
        path: "/admin/collections",
        icon: <StorageIcon />,
        requiredPermission: "view_all_database",
        description: "Visor técnico de colecciones"
      },
    ]
  },
];

/**
 * Función de verificación robusta
 * @param {Object} item El item de navegación
 * @param {String} userRole El rol actual
 * @param {Array} userPermissions Lista de permisos cargada dinámicamente
 */
export const hasAccess = (item, userRole, userPermissions = []) => {
  // 1. Super Admin siempre entra (Master Key)
  if (userRole === ROLES.SUPER_ADMIN) return true;

  // 2. Si hay roles específicos excluyentes (por seguridad crítica)
  if (item.roles && item.roles.length > 0) {
    if (!item.roles.includes(userRole)) return false;
  }

  // 3. Verificación por Permisos (Matriz Dinámica)
  if (item.requiredPermission) {
    return userPermissions.includes(item.requiredPermission);
  }

  // 4. Si no tiene requisitos, es público para logueados
  return true;
};
